import React, { useState } from 'react';
import texts from '../content/texts';

const Honeymoon = () => {
  const [showIban, setShowIban] = useState(false);
  const [ibanCopied, setIbanCopied] = useState(false);
  
  const iban = "IT94G0339512900052870666830";
  
  const handleCopyIban = () => {
    navigator.clipboard.writeText(iban)
      .then(() => {
        setIbanCopied(true);
        setTimeout(() => setIbanCopied(false), 2000);
      })
      .catch(err => {
        console.error('Errore durante la copia: ', err);
      });
  };

  return (
    <section id="honeymoon">
      <span className="line"></span> {/* Linea separatrice */}
      <div className="story-section">
        <h2 className="story-title font-detail">Il Nostro Viaggio</h2>
        <div className="honeymoon-intro">
          <p className="font-detail">{texts.honeymoon.content}</p>
        </div>
        
        <div className="honeymoon-container">
          <div className="card destination-card japan">
            <div className="destination-icon">🗼 ⛩️</div>
            <h3 className="destination-title font uppercase">Giappone 🇯🇵</h3>
            <div className="destination-description">
              <p className="font-detail font-hooneymoon">{texts.giappone.content}</p>
            </div>
          </div>
          
          <div className="card destination-card thailand">
            <div className="destination-icon">🐘 🌴</div>
            <h3 className="destination-title font uppercase">Thailandia 🇹🇭</h3>
            <div className="destination-description">
              <p className="font-detail font-hooneymoon">{texts.thailandia.content}</p>
            </div>
          </div>
        </div>
        
        <span className="line"></span>
        <h2 className="font-header">{texts.gift.title}</h2>
        <div className="gift-section important-note">
          <p className="font-detail">Il vostro affetto e la vostra presenza saranno il dono più grande in questo giorno speciale.</p>
          <p className="font-detail">Se vorrete accompagnarci anche in questo sogno, il vostro pensiero renderà ancora più preziosa questa nuova avventura insieme.</p>
          <p className="font-detail">Ne saremo profondamente grati.</p>
        </div>
      </div>
    </section>
  );
};

export default Honeymoon;
